import { Component,OnInit,Input,OnDestroy,Output,EventEmitter } from "@angular/core";
import { Subject } from "rxjs";
import { takeWhile } from "rxjs/operators";

import { PagingInfo } from "src/app/shared/vo";

@Component({
    selector: "list-paging"
    ,templateUrl: "./list.paging.component.html"
    ,styleUrls: ["./list.paging.component.scss"]
    ,providers:[]
})
export class ListPagingComponent implements OnInit,OnDestroy {
    isContinue:boolean = true;
    pagingInfo:PagingInfo = new PagingInfo();
    listCountRowPerPage:any[] = [];
    @Output() callbackChangeCountRowPerPage = new EventEmitter();
    @Output() callbackClickPageNumber = new EventEmitter();

    constructor(

    ) {

    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngOnInit() {

    }

    @Input()
    set inputPagingInfo(pagingInfo:PagingInfo){
        this.pagingInfo = pagingInfo;
        this.initListPageNumber();
        this.initListCountRowPerPage();
    }

    initListPageNumber(){
        // console.log("initListPageNumber",this.pagingInfo);
        this.pagingInfo.listPageNumber = new Array();
        for(let numPage = this.pagingInfo.startPage; numPage <= this.pagingInfo.endPage; numPage++){
            this.pagingInfo.listPageNumber.push(numPage);
        }
    }

    initListCountRowPerPage(){
        this.listCountRowPerPage = [];
        for(let a=1;a<=10;a++){
            this.listCountRowPerPage.push(a * 10);
        }
    }

    changeCountRowPerPage(pageSize:number){
        this.callbackChangeCountRowPerPage.emit(pageSize);
    }

    clickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.callbackClickPageNumber.emit(selectedPage);
    }
}
